module.exports = "<app-alert></app-alert>\n<router-outlet></router-outlet>"